module.exports = __webpack_public_path__ + "static/media/ST5.18bd086a.mp3";